import { addEventListener, removeEventListener } from '@okee-uikit/react-hooks';
import { useRefCallback } from '@okee-uikit/react-hooks';
import { useCallback, useEffect, useRef } from 'react';
export function useWaveAnimation() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a;

  var defaultElementRef = useRef(null);
  var defaultTriggerRef = useRef(null);
  var timerRef = useRef(null);
  var _options$disabled = options.disabled,
      disabled = _options$disabled === void 0 ? false : _options$disabled,
      _options$elementRef = options.elementRef,
      elementRef = _options$elementRef === void 0 ? defaultElementRef : _options$elementRef,
      _options$eventType = options.eventType,
      eventType = _options$eventType === void 0 ? 'capture:click' : _options$eventType,
      _options$pseudoElemen = options.pseudoElement,
      pseudoElement = _options$pseudoElemen === void 0 ? 'after' : _options$pseudoElemen;
  var triggerRef = (_a = options.triggerRef) !== null && _a !== void 0 ? _a : elementRef === defaultElementRef ? elementRef : defaultTriggerRef;
  var handleEvent = useCallback(function () {
    var element = elementRef.current;

    if (!element || disabled) {
      return;
    }

    element.removeAttribute('data-motion-wave');
    setTimeout(function () {
      return element.setAttribute('data-motion-wave', pseudoElement);
    }, 0);

    if (timerRef.current !== null) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(function () {
      element.removeAttribute('data-motion-wave');
    }, 2000);
  }, [disabled, elementRef, pseudoElement]);
  var handleEventRef = useRefCallback(handleEvent);
  useEffect(function () {
    var trigger = triggerRef.current;

    if (!trigger) {
      return;
    }

    addEventListener(trigger, eventType, handleEventRef, true);
    return function () {
      return removeEventListener(trigger, eventType, handleEventRef);
    };
  }, []);
  return triggerRef;
}